import { type FunctionComponent } from "react";

import { PlusNewsAgendaLeftPlaceholder } from "./left";
import { PlusNewsAgendaRightPlaceholder } from "./right";
import { Content } from "./styles";

type Props = {
  className?: string;
};

export const PlusNewsAgendaPlaceholder: FunctionComponent<Props> = () => (
  <Content>
    <PlusNewsAgendaLeftPlaceholder />
    <PlusNewsAgendaRightPlaceholder />
  </Content>
);

PlusNewsAgendaPlaceholder.displayName = "PlusNewsAgendaPlaceholder";
